module.exports = __webpack_public_path__ + "img/pricing-tree-2.1152cb85.png";